import { useEffect, useState } from "react";

import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { _FixedAssetItem } from "../../../../../../../core/services/dataBean/EntityCatalogVdos";
import { toast } from "react-toastify";

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const SelectFixedAssetOperationalStateConstants = ({ idSelector, onChange, label }: Props) => {

    const { instance, setBean, setLista, bean, lista } = useDataBean(_FixedAssetItem)
    const [id, setID] = useState<number>(null);

    useEffect(() => {
        setID(idSelector);
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: any) => {
        setID(e);
        onChange(e);
    }

    const getLista = () => {
        instance.getFixedAssetOperationalStateConstants(null).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(err => { toast.error(err) })
    }

    return (
        <>
            <label>{label ?? "Estado del Obejto"}</label>
            <select className="form-select" value={id} onChange={(e) => {
                const value = e.target.value ? Number(e.target.value) : null;
                setValue(value);
            }}>
                <option value={""}>...</option>
                {lista &&
                    lista.map((item: any) => {
                        return (
                            <option key={item.DataBeanProperties.Value} value={item.DataBeanProperties.Value} >{item.DataBeanProperties.Property}</option>
                        )
                    })
                }
            </select>
        </>
    )
}